export default [
  {
    title: "الرئيسية",
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: "ادارة الجداول",
    route: 'tables',
    icon: 'TrelloIcon',
  },
  {
    title: "ادارة المعلمين",
    route: 'teachers',
    icon: 'UsersIcon',
  },
  {
    title: "ادارة المواد",
    route: 'subjects',
    icon: 'BookIcon',
  },
  {
    title: "ادارة الفصول",
    route: 'classrooms',
    icon: 'ColumnsIcon',
  },
  {
    title: "الإعدادات",
    icon: 'SettingsIcon',
    children: [
      {
        title: 'الأيام والحصص',
        route: 'times',
      }
    ],
  },
  {
    title: "حصص الانتظار - قريباً",
    route: 'waiting',
    icon: 'ClockIcon',
  },
  {
    title: "المهام اليومية - قريباً",
    route: 'tasks',
    icon: 'CheckSquareIcon',
  },
]
